import { shoppingCartActionTypes } from "../../actionTypes/shoppingCart/shoppingCart.actionTypes";

// Helper function to load state from localStorage
const loadCartStateFromLocalStorage = () => {
  try {
    const serializedState = localStorage.getItem("shoppingCartState");
    return serializedState ? JSON.parse(serializedState) : undefined;
  } catch (err) {
    console.error("Failed to load state from localStorage:", err);
    return undefined;
  }
};

// Initial state, loaded from localStorage if available
const initialState = loadCartStateFromLocalStorage() || {
  shoppingCartItems: [], // Default empty cart
};

const shoppingCartReducer = (state = initialState, action) => {
  switch (action.type) {
    case shoppingCartActionTypes.ADD_TO_CART:
      return addItemToCart(state, action.payload);
    case shoppingCartActionTypes.REMOVE_FROM_CART:
      return removeItemFromCart(state, action.payload);
    case shoppingCartActionTypes.UPDATE_CART_ITEM:
      return updateCartItem(state, action.payload);
    case shoppingCartActionTypes.CLEAR_CART:
      return { ...state, shoppingCartItems: [] };
    default:
      return state;
  }
};

// Helper function to add an item to the cart
const addItemToCart = (state, item) => {
  const existingItem = state.shoppingCartItems.find((cartItem) => cartItem.id === item.id);

  if (existingItem) {
    // If the item already exists, increase its quantity
    return {
      ...state,
      shoppingCartItems: state.shoppingCartItems.map((cartItem) =>
        cartItem.id === item.id
          ? {
              ...cartItem,
              quantity: cartItem.quantity + item.quantity,
            }
          : cartItem
      ),
    };
  }

  // Add the new item to the cart
  return {
    ...state,
    shoppingCartItems: [...state.shoppingCartItems, { ...item, quantity: item.quantity  }],
  };
};

// Helper function to remove an item from the cart
const removeItemFromCart = (state, itemId) => {
  return {
    ...state,
    shoppingCartItems: state.shoppingCartItems.filter((cartItem) => cartItem.id !== itemId),
  };
};

// Helper function to update an item's quantity or details in the cart
const updateCartItem = (state, updatedItem) => {
  return {
    ...state,
    shoppingCartItems: state.shoppingCartItems.map((cartItem) => (cartItem.id === updatedItem.id ? { ...cartItem, ...updatedItem } : cartItem)),
  };
};

export default shoppingCartReducer;
